<template>
  <a-layout id="components-layout-demo-side" style="min-height: 100vh">
    <a-layout-sider v-model="collapsed">
      <div class="logo-container">
        <img src="/logo.png" alt="logo" class="logo-pic" />
        <span class="logo-title">光伏项目管理系统</span>
      </div>
      <LeftMenu />
    </a-layout-sider>
    <a-layout>
      <HzzHeader />
      <a-layout-content style="margin: 0 16px">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view
            :key="$route.path + $route.query.t"
            v-if="!$route.meta.keepAlive"
        />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import HzzHeader from "@/components/HzzHeader";
import LeftMenu from "@/components/LeftMenu";

export default {
  components: {
    HzzHeader,
    LeftMenu
  },
  data() {
    return {
      collapsed: false,
    };
  },
};
</script>

<style scoped>
.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}
.logo-title {
  margin-top: 10px;
  color: white;
  font-size: 20px;
  font-weight: bold;
}
</style>
